// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.landlord.UndoMarkOneTimePaymentAsPaidOfflineWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { UndoMarkOneTimePaymentAsPaidOfflineWebApiHandler_undoMarkOneTimePaymentAsPaidOffline } from '@zg-rentals/ts-rent-payment-client';

import type { UndoMarkOneTimePaymentAsPaidOfflineWebApiRequestDto } from '@zg-rentals/ts-rent-payment-client';

export interface UndoMarkOneTimePaymentAsPaidOfflineWebApiHandler_undoMarkOneTimePaymentAsPaidOffline_Args {
  postData: UndoMarkOneTimePaymentAsPaidOfflineWebApiRequestDto;
}

export type UndoMarkOneTimePaymentAsPaidOfflineWebApiHandler_undoMarkOneTimePaymentAsPaidOffline_Options =
  UseMutationOptions<
    void,
    unknown,
    UndoMarkOneTimePaymentAsPaidOfflineWebApiHandler_undoMarkOneTimePaymentAsPaidOffline_Args
  >;

/**
 * Undo a one-time payment or move-in costs group previously marked as received offline by the landlord
 */
export const useUndoMarkOneTimePaymentAsPaidOfflineWebApiHandler_undoMarkOneTimePaymentAsPaidOffline = ({
  httpClient,
  ...options
}: Omit<UndoMarkOneTimePaymentAsPaidOfflineWebApiHandler_undoMarkOneTimePaymentAsPaidOffline_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: UndoMarkOneTimePaymentAsPaidOfflineWebApiHandler_undoMarkOneTimePaymentAsPaidOffline_Args) =>
      UndoMarkOneTimePaymentAsPaidOfflineWebApiHandler_undoMarkOneTimePaymentAsPaidOffline(args.postData, httpClient),
  });
};
